/* tslint:disable */
/* eslint-disable */
/**
 * Famifarm-API
 * Famifarm API specification
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PackagingFilmBatch
 */
export interface PackagingFilmBatch {
    /**
     * 
     * @type {string}
     * @memberof PackagingFilmBatch
     */
    id?: string;
    /**
     * Packaging film batch name
     * @type {string}
     * @memberof PackagingFilmBatch
     */
    name?: string;
    /**
     * Time when the packaging film batch has arrived
     * @type {Date}
     * @memberof PackagingFilmBatch
     */
    time?: Date;
    /**
     * if packaging film batch is active
     * @type {boolean}
     * @memberof PackagingFilmBatch
     */
    active?: boolean;
}

export function PackagingFilmBatchFromJSON(json: any): PackagingFilmBatch {
    return PackagingFilmBatchFromJSONTyped(json, false);
}

export function PackagingFilmBatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): PackagingFilmBatch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'time': !exists(json, 'time') ? undefined : (new Date(json['time'])),
        'active': !exists(json, 'active') ? undefined : json['active'],
    };
}

export function PackagingFilmBatchToJSON(value?: PackagingFilmBatch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'time': value.time === undefined ? undefined : (value.time.toISOString()),
        'active': value.active,
    };
}


